export default class StringService {
    static capitalize(string) {
        if (!string) {
            return string;
        }
        return string[0].toUpperCase() + string.slice(1);
    }
    static unCapitalize(string) {
        if (!string) {
            return string;
        }
        return string[0].toLowerCase() + string.slice(1);
    }
}
